module.exports = __webpack_public_path__ + "static/media/katerina_Marzuqa.0b774dd2.jpg";